/**
 * Hide element.
 * @param {Node/String} el Element or selector.
 */
export function hide(el) { // jshint ignore: line
  Array.from(arguments).forEach((el) => {
    if (typeof el === 'string') {
      document.querySelector(el).classList.add('d-none');
    } else {
      el.classList.add('d-none');
    }
  })
}

/**
 * Show element.
 * @param {Node/String} el Element or selector.
 */
export function show(el) { // jshint ignore: line
  Array.from(arguments).forEach((el) => {
    if (typeof el === 'string') {
      document.querySelector(el).classList.remove('d-none');
    } else {
      el.classList.remove('d-none');
    }
  })
}

export const getDataFromScript = ( scriptAttr ) => {
  const dataEl = document.querySelector(`script[${ scriptAttr }]`);
  if (!dataEl) {
    return;
  }

  let data;
  try {
    data = JSON.parse(dataEl.innerHTML);
    return data;
  } catch (e) {
    console.error(`[${ scriptAttr }] Can not parse data.`, dataEl.innerHTML);
    throw e;
  }
}

/**
 * Generate UUID.
 * @return {String}
 */
export const uuid = () => {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}
